import React from 'react';

const AdmissionPolicy = () => {
  return (
    <div>
      AdmissionPolicy
      AdmissionPolicy
    </div>
  );
}

export default AdmissionPolicy;
